module.exports = __webpack_public_path__ + "static/media/book.daed145e.svg";